/**
 * Fullbleed video (or photo) band between the polaroid gallery and Instagram section.
 * To use a VIDEO: set videoSrc to your video file/URL (mp4). It autoplays muted+looped.
 * To use a PHOTO instead: leave videoSrc empty and set imageSrc.
 */
const videoSrc =
  "https://res.cloudinary.com/dnggmrgmu/video/upload/w_1200,f_auto,q_auto:eco/v1782847081/video_vo9xg8.mp4";
const imageSrc = "https://res.cloudinary.com/dnggmrgmu/image/upload/w_1200,f_auto,q_auto/v1783264960/market_gpovuc.jpg"; // fallback / photo mode
export function MediaBand() {
  return (
    <section className="relative h-[60vh] w-full overflow-hidden sm:h-[75vh]">
      {videoSrc ? (
        <video
          src={videoSrc}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <img
          src={imageSrc}
          alt="Mr. Pizza Steve Finds"
          className="absolute inset-0 h-full w-full object-cover"
        />
      )}
      <div className="absolute inset-0 bg-background/60" />
    </section>
  );
}